import type { Event } from '@cocoonspace/sdk-js/types/event'
import { EventShareWidgetFooter } from '../molecules/event-share-widget-footer'
import { EventShareWidgetContent } from './event-share-dialog/event-share-widget-content'

export const EventShareWidget = ({
	event,
	onInvitationsSent,
}: {
	event: Event
	onInvitationsSent?: (guestCount: number) => void
}) => (
	<div className='flex flex-col gap-y-4'>
		{event.is_organizer && (
			<>
				<EventShareWidgetContent
					events={[event]}
					onInvitationsSent={onInvitationsSent}
				/>

				<hr />
			</>
		)}

		<EventShareWidgetFooter event={event} />
	</div>
)
